(function () {
  'use strict';

  function parseRuleNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function standard() {
    return window.AxiomStandardStorefront || null;
  }

  function cartString(key, fallback) {
    return (window.Axiom && window.Axiom.cartStrings && window.Axiom.cartStrings[key]) || fallback || '';
  }

  function getCartLines(cart) {
    return standard() && typeof standard().getCartLines === 'function' ? standard().getCartLines(cart) : [];
  }

  function getCartTotalQuantity(cart) {
    return standard() && typeof standard().getCartTotalQuantity === 'function' ? standard().getCartTotalQuantity(cart) : 0;
  }

  function updateCartCount(count) {
    if (window.Axiom && typeof window.Axiom.updateCartCount === 'function') {
      window.Axiom.updateCartCount(count);
      return;
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      var valueEl = element.querySelector('[data-cart-count-value]') || element;
      valueEl.textContent = count;
      element.style.display = count > 0 ? '' : 'none';
    });
  }

  function getQuantityRule(input) {
    return {
      min: Math.max(1, parseRuleNumber(input && input.dataset.minRule, 1)),
      max: input && input.dataset.maxRule !== '' && input.dataset.maxRule !== undefined
        ? parseRuleNumber(input.dataset.maxRule, null)
        : null,
      step: Math.max(1, parseRuleNumber(input && input.dataset.stepRule, 1))
    };
  }

  function normalizeCartQuantity(rawValue, rule, allowZero) {
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : rule.min;
    if (allowZero && value <= 0) return 0;
    if (value < rule.min) value = rule.min;
    if (value > rule.min) value -= (value - rule.min) % rule.step;
    if (rule.max !== null && value > rule.max) {
      value = rule.max;
      if (value >= rule.min) value -= (value - rule.min) % rule.step;
    }
    return Math.max(allowZero ? 0 : rule.min, value);
  }

  function getNextCartQuantity(input, direction) {
    var rule = getQuantityRule(input);
    var current = parseInt(input.value, 10);
    if (!Number.isFinite(current)) current = 0;
    var requested = direction > 0
      ? (current <= 0 ? rule.min : current + rule.step)
      : (current <= rule.min ? 0 : current - rule.step);

    return {
      requested: requested,
      value: normalizeCartQuantity(requested, rule, direction <= 0)
    };
  }

  function setFormLoading(root, loading) {
    if (!root) return;
    root.classList.toggle('is-updating', Boolean(loading));
    root.querySelectorAll('.cart-qty__btn, .cart-qty__input, [data-cart-clear]').forEach(function (control) {
      control.disabled = Boolean(loading);
    });
  }

  function setCartLineUpdating(root, lines, loading) {
    if (!root) return;
    var lineList = Array.isArray(lines) ? lines.filter(Boolean) : (lines ? [lines] : []);
    var rows = lineList.length
      ? lineList.map(function (line) {
        return root.querySelector('.cart-table__row[data-line="' + line + '"]');
      }).filter(Boolean)
      : Array.from(root.querySelectorAll('.cart-table__row'));
    rows.forEach(function (row) {
      row.classList.toggle('is-updating', Boolean(loading));
      row.setAttribute('aria-busy', loading ? 'true' : 'false');
      var status = row.querySelector('[data-cart-line-loading-status]');
      if (status) status.textContent = loading ? cartString('updating', 'Loading') : '';
    });
  }

  function clearCartLineUpdating(root) {
    if (!root) return;
    root.querySelectorAll('.cart-table__row.is-updating').forEach(function (row) {
      row.classList.remove('is-updating');
      row.setAttribute('aria-busy', 'false');
      var status = row.querySelector('[data-cart-line-loading-status]');
      if (status) status.textContent = '';
    });
  }

  function setAlert(alert, message) {
    if (!alert) return;
    alert.textContent = '';
    alert.hidden = !message;
    if (!message) return;
    window.requestAnimationFrame(function () {
      if (alert.isConnected) alert.textContent = message;
    });
  }

  function clearCartFeedback(root) {
    if (!root) return;
    setAlert(root.querySelector('[data-cart-status]'), '');
    root.querySelectorAll('[data-cart-line-error]').forEach(function (alert) {
      setAlert(alert, '');
    });
    root.querySelectorAll('.cart-qty__input[aria-invalid="true"]').forEach(function (input) {
      input.removeAttribute('aria-invalid');
    });
  }

  function findCartRow(root, identifier, lineNumber) {
    if (root && lineNumber) {
      var lineRow = root.querySelector('.cart-table__row[data-line="' + lineNumber + '"]');
      if (lineRow) return lineRow;
    }
    var id = String(identifier || '');
    return Array.from(root ? root.querySelectorAll('.cart-table__row[data-cart-line-id]') : []).find(function (row) {
      return String(row.dataset.cartLineId || '') === id;
    }) || null;
  }

  function showCartLineFeedback(root, identifier, message, lineNumber) {
    if (!root || !message) return;
    var row = findCartRow(root, identifier, lineNumber);
    var alert = row && row.querySelector('[data-cart-line-error]');
    var input = row && row.querySelector('.cart-qty__input');
    if (input) input.setAttribute('aria-invalid', 'true');
    setAlert(alert || root.querySelector('[data-cart-status]'), message);
  }

  function showInputFeedback(root, input, message) {
    if (!root || !input || !message) return;
    var row = input.closest('.cart-table__row');
    setAlert((row && row.querySelector('[data-cart-line-error]')) || root.querySelector('[data-cart-status]'), message);
  }

  function quantityLimitMessage(count) {
    return standard().quantityLimitMessage(count);
  }

  function annotateCartLineIds(root, cart) {
    var lines = getCartLines(cart);
    if (!root || !lines.length) return;
    root.querySelectorAll('.cart-table__row').forEach(function (row, index) {
      var line = lines[index];
      if (!line || !line.id) return;
      row.dataset.cartLineId = line.id;
      row.querySelectorAll('.cart-qty__btn, .cart-qty__input').forEach(function (control) {
        control.dataset.cartLineId = line.id;
      });
    });
  }

  function hasCartLineIds(root) {
    var inputs = root ? Array.from(root.querySelectorAll('.cart-qty__input')) : [];
    return inputs.length > 0 && inputs.every(function (input) {
      return Boolean(input.dataset.cartLineId);
    });
  }

  function ensureCartLineIds(root) {
    if (hasCartLineIds(root)) return Promise.resolve(root);
    if (!root || !standard() || typeof standard().getCart !== 'function') {
      return Promise.reject(new Error(cartString('updateError', 'We could not update this item. Please try again.')));
    }
    if (root._cartLineIdsPromise) return root._cartLineIdsPromise;

    root._cartLineIdsPromise = standard().getCart()
      .then(function (cart) {
        annotateCartLineIds(root, cart);
        if (!hasCartLineIds(root)) {
          throw new Error(cartString('updateError', 'We could not update this item. Please try again.'));
        }
        return root;
      })
      .finally(function () {
        root._cartLineIdsPromise = null;
      });

    return root._cartLineIdsPromise;
  }

  function renderCartSection(root, preserveNote, cart) {
    var sectionId = root && root.dataset.sectionId;
    if (!sectionId) return Promise.reject(new Error('Missing cart section id'));
    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    return fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart section render failed');
        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var replacement = documentFragment.querySelector('[data-cart-page]');
        if (!replacement || !root.parentNode) throw new Error('Cart section markup missing');
        root.replaceWith(replacement);
        if (typeof preserveNote === 'string') {
          var note = replacement.querySelector('[data-cart-note]');
          if (note) note.value = preserveNote;
        }
        bindCartPage(replacement);
        annotateCartLineIds(replacement, cart);
        document.dispatchEvent(new CustomEvent('cart:page:rendered', {
          detail: { cartPage: replacement }
        }));
        return replacement;
      });
  }

  function requestedLines(root) {
    return Array.from(root.querySelectorAll('.cart-qty__input')).map(function (input) {
      input.value = normalizeCartQuantity(input.value, getQuantityRule(input), true);
      return {
        id: input.dataset.cartLineId,
        quantity: parseInt(input.value, 10) || 0,
        line: input.dataset.line || '',
        serverQuantity: parseInt(input.defaultValue, 10) || 0
      };
    }).filter(function (line) {
      return Boolean(line.id);
    });
  }

  function feedbackForResult(result, requested, changedLines) {
    var resultLines = getCartLines(result && result.cart);
    var actualById = new Map(resultLines.map(function (line) {
      return [String(line.id || ''), Number(line.quantity) || 0];
    }));
    var relevant = changedLines && changedLines.length
      ? requested.filter(function (line) { return changedLines.indexOf(String(line.line)) !== -1; })
      : requested;
    var inventoryWarning = (result && Array.isArray(result.warnings) ? result.warnings : []).find(function (warning) {
      return warning && (warning.code === 'MERCHANDISE_NOT_ENOUGH_STOCK' || warning.code === 'MERCHANDISE_OUT_OF_STOCK');
    });
    if (inventoryWarning) {
      var warningTarget = String(inventoryWarning.target || '');
      var warningLineIndex = resultLines.findIndex(function (line) {
        return line && String(line.id || '') === warningTarget;
      });
      var warningLine = warningLineIndex >= 0 ? resultLines[warningLineIndex] : null;
      var warningRequest = relevant.find(function (line) {
        return String(line.id || '') === warningTarget;
      }) || relevant.find(function (line) {
        return Number(line.line) === warningLineIndex + 1;
      }) || relevant[0];
      if (warningRequest && warningRequest.quantity > 0) {
        return {
          id: warningLine && warningLine.id || warningRequest.id,
          line: warningRequest.line,
          message: quantityLimitMessage(warningLine ? Number(warningLine.quantity) : warningRequest.serverQuantity)
        };
      }
    }
    var adjusted = relevant.find(function (line) {
      if (line.quantity <= 0) return false;
      var resultLine = resultLines[Number(line.line) - 1];
      var actualQuantity = actualById.has(String(line.id))
        ? actualById.get(String(line.id))
        : resultLine && Number(resultLine.quantity);
      return Number.isFinite(actualQuantity) && actualQuantity !== line.quantity;
    });
    if (adjusted) {
      var adjustedResultLine = resultLines[Number(adjusted.line) - 1];
      var adjustedQuantity = actualById.has(String(adjusted.id))
        ? actualById.get(String(adjusted.id))
        : adjustedResultLine && Number(adjustedResultLine.quantity);
      return {
        id: adjustedResultLine && adjustedResultLine.id || adjusted.id,
        line: adjusted.line,
        message: quantityLimitMessage(adjustedQuantity)
      };
    }
    return null;
  }

  function submitCartUpdates(root) {
    if (!root || root._cartPageRequestActive) return;
    var form = root.querySelector('#cart-form');
    if (!form) return;
    if (root._cartPageUpdateTimer) {
      window.clearTimeout(root._cartPageUpdateTimer);
      root._cartPageUpdateTimer = null;
    }

    root._cartPageRequestActive = true;
    clearCartFeedback(root);
    var preserveNote = (form.querySelector('[data-cart-note]') || {}).value || '';
    var lines = [];
    var changedLine = root._cartPageChangedLine || '';
    var changedLines = root._cartPageChangedLines ? Array.from(root._cartPageChangedLines) : (changedLine ? [changedLine] : []);
    root._cartPageChangedLines = new Set();
    setFormLoading(root, true);
    setCartLineUpdating(root, changedLines, true);

    ensureCartLineIds(root)
      .then(function () {
        lines = requestedLines(root);
        return standard().updateCart({
          lines: lines.map(function (line) {
            return { id: line.id, quantity: line.quantity };
          }),
          note: preserveNote
        }, {
          target: root,
          context: 'cart',
          source: 'cart-page'
        });
      })
      .then(function (result) {
        updateCartCount(getCartTotalQuantity(result.cart));
        var feedback = feedbackForResult(result, lines, changedLines);
        return renderCartSection(root, preserveNote, result.cart).then(function (replacement) {
          if (feedback) showCartLineFeedback(replacement, feedback.id, feedback.message, feedback.line);
          return replacement;
        });
      })
      .catch(function (error) {
        var currentRoot = document.querySelector('[data-cart-page]') || root;
        currentRoot.querySelectorAll('.cart-qty__input').forEach(function (input) {
          input.value = input.defaultValue;
        });
        var failedRequest = lines.find(function (line) {
          return String(line.line) === String(changedLine);
        }) || lines[0];
        var changedInput = failedRequest
          ? currentRoot.querySelector('.cart-qty__input[data-line="' + failedRequest.line + '"]')
          : null;
        var firstInput = changedInput || currentRoot.querySelector('.cart-qty__input');
        var identifier = firstInput && firstInput.dataset.cartLineId || failedRequest && failedRequest.id;
        var serverQuantity = failedRequest ? failedRequest.serverQuantity : NaN;
        var message = error && error.code === 'MAXIMUM_EXCEEDED' && Number.isFinite(serverQuantity)
          ? quantityLimitMessage(serverQuantity)
          : error && error.message || cartString('updateError', 'We could not update this item. Please try again.');
        if (identifier) showCartLineFeedback(currentRoot, identifier, message, failedRequest && failedRequest.line);
        else setAlert(currentRoot.querySelector('[data-cart-status]'), message);
      })
      .finally(function () {
        var currentRoot = document.querySelector('[data-cart-page]') || root;
        currentRoot._cartPageRequestActive = false;
        clearCartLineUpdating(currentRoot);
        setFormLoading(currentRoot, false);
      });
  }

  function scheduleCartUpdate(root, input) {
    if (!root) return;
    if (input) {
      root._cartPageChangedLine = input.dataset.line || '';
      if (!root._cartPageChangedLines) root._cartPageChangedLines = new Set();
      if (input.dataset.line) root._cartPageChangedLines.add(input.dataset.line);
    }
    if (root._cartPageUpdateTimer) window.clearTimeout(root._cartPageUpdateTimer);
    root._cartPageUpdateTimer = window.setTimeout(function () {
      root._cartPageUpdateTimer = null;
      submitCartUpdates(root);
    }, 300);
  }

  function clearCart(root) {
    setFormLoading(root, true);
    return standard().clearCart({ target: root, source: 'cart-page' })
      .then(function (result) {
        updateCartCount(getCartTotalQuantity(result.cart));
        return renderCartSection(root, '', result.cart);
      })
      .catch(function (error) {
        setAlert(root.querySelector('[data-cart-status]'), error && error.message || cartString('updateError'));
      })
      .finally(function () {
        setFormLoading(document.querySelector('[data-cart-page]') || root, false);
      });
  }

  function bindCartPage(root) {
    if (!root || root.dataset.cartPageBound === 'true') return;
    root.dataset.cartPageBound = 'true';
    var form = root.querySelector('#cart-form');
    if (!form) return;

    root.addEventListener('click', function (event) {
      var clearButton = event.target.closest('[data-cart-clear]');
      if (!clearButton) return;
      event.preventDefault();
      clearCart(root);
    });

    form.addEventListener('click', function (event) {
      var button = event.target.closest('.cart-qty__btn');
      if (!button) return;
      event.preventDefault();
      var input = form.querySelector('.cart-qty__input[data-line="' + button.dataset.line + '"]');
      if (!input) return;
      clearCartFeedback(root);
      var next = getNextCartQuantity(input, parseInt(button.dataset.change, 10));
      input.value = next.value;
      if (next.value !== next.requested) showInputFeedback(root, input, quantityLimitMessage(next.value));
      scheduleCartUpdate(root, input);
    });

    form.addEventListener('change', function (event) {
      var input = event.target.closest('.cart-qty__input');
      if (!input) return;
      clearCartFeedback(root);
      var rawValue = parseInt(input.value, 10);
      var normalized = normalizeCartQuantity(rawValue, getQuantityRule(input), true);
      input.value = normalized;
      if (Number.isFinite(rawValue) && rawValue !== normalized) showInputFeedback(root, input, quantityLimitMessage(normalized));
      scheduleCartUpdate(root, input);
    });

    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter.name === 'checkout') return;
      event.preventDefault();
      submitCartUpdates(root);
    });

    if (window.Axiom && typeof window.Axiom.initCartShippingEstimators === 'function') {
      window.Axiom.initCartShippingEstimators(root);
    }
    ensureCartLineIds(root).catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-cart-page]').forEach(bindCartPage);
  }

  window.Axiom = Object.assign(window.Axiom || {}, {
    cartPage: {
      renderStandard: function (cart) {
        var root = document.querySelector('[data-cart-page]');
        return root ? renderCartSection(root, null, cart) : Promise.resolve(cart);
      }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
